import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import usePageMeta from '@/hooks/usePageMeta';
import FaqHeader from './components/FaqHeader';
import FaqAccordion from './components/FaqAccordion';

export default function Faq() {
  usePageMeta(
    '常见问题 - 更新提醒与进度保存 | 我爱漫画网',
    '我爱漫画网常见问题解答：如何开启连载更新提醒、收藏与进度如何保存、追漫日历如何使用等，为漫画迷提供追更收藏的完整指引。'
  );

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Navbar />
      <main>
        <FaqHeader />
        <FaqAccordion />
      </main>
      <Footer />
    </div>
  );
}